import { jsx } from "react/jsx-runtime";
import React, { useCallback, useState } from "react";
export const useDialog = ({ ModalComponent }) => {
  const [isOpen, setOpen] = useState(false);
  const [additionalProps, setAdditionalProps] = useState(false);
  const Comp = useCallback(
    () => /* @__PURE__ */ jsx(
      ModalComponent,
      {
        hideModal: () => {
          setOpen(false);
        },
        hideDialog: () => {
          setOpen(false);
        },
        ...additionalProps,
        dialogProps: {
          isOpen,
          ...additionalProps?.dialogProps
        }
      }
    ),
    [ModalComponent, additionalProps, isOpen]
  );
  const showDialogPromise = useCallback(async (handlerName, moreProps = {}) => {
    return new Promise((resolve) => {
      setAdditionalProps({
        hideModal: () => {
          setOpen(false);
          resolve({});
        },
        hideDialog: () => {
          setOpen(false);
          resolve({});
        },
        [handlerName]: (r) => {
          setOpen(false);
          resolve(r || {});
        },
        //pass any additional props to the dialog
        ...moreProps
      });
      setOpen(true);
    });
  }, []);
  return { Comp, showDialogPromise };
};
